var _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProsharesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ProShares") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#1C8C4B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.74 3.07) scale(0.29)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07511 10.276C8.49459 7.01823 13.4337 4.97156 19.1069 5.70227C24.6278 6.41269 28.0378 11.9708 27.0229 14.7956C27.5879 14.4641 29.1948 12.6441 29.4147 10.5365C29.9052 5.86803 23.9242 1.25709 15.8153 0.211761C7.70299 -0.833566 0.642798 2.09267 0.040635 6.75097C-0.558145 11.4093 5.53114 16.0304 13.6434 17.0757C14.5433 17.1907 15.4296 17.255 16.2956 17.2787C11.2821 16.257 7.68607 13.28 8.07511 10.276Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45491 25.5227C9.25937 27.1499 13.7654 25.0187 16.5225 20.7663C19.2052 16.629 19.2323 12.0147 16.6511 10.2725C17.4122 10.3773 18.1294 10.6108 18.7789 10.9863C22.7877 13.307 22.8419 20.1202 18.9007 26.2027C14.9562 32.2818 8.51173 35.3265 4.50634 33.0058C0.497555 30.6817 0.443433 23.8719 4.38455 17.7893C4.82434 17.1128 5.29118 16.4802 5.7817 15.8814C3.64369 19.8597 3.87035 24.0309 6.45491 25.5227Z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProsharesCircle);
export default __webpack_public_path__ + "static/media/proshares-circle.f1f599deeb52cf3513a9130545bcfa78.svg";
export { ForwardRef as ReactComponent };